/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFaqImageDto } from '../../models/lexplus-faq-image-dto';

export interface FaqControllerUploadImageV1$Params {
      body: {
'file': Blob;
}
}

export function faqControllerUploadImageV1(http: HttpClient, rootUrl: string, params: FaqControllerUploadImageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFaqImageDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerUploadImageV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFaqImageDto>;
    })
  );
}

faqControllerUploadImageV1.PATH = '/v1/faq/images';
